import { Config } from '../../../responses/refs/refs'
import { combineReducers } from 'redux'
import { createAction, createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import { RequestStatus } from '../../../responses/response'
import { RootEpic } from '../../root'
import { filter, map, mergeMap, switchMap } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'
import { payloadReducer } from '../../../utils/redux-utils'
import { combineEpics } from 'redux-observable'
import { entityReplace } from '../../../utils/entity-utils'
import { ADTType, makeADT, ofType } from '@morphic-ts/adt'


export const ConfigEditState = makeADT('type')({
    none: ofType<{type: 'none'}>(),
    update: ofType<{type: 'update', payload: Config}>()
})

const actions = {
    list: createAsyncAction(
        '@CONFIG/LIST_REQUEST',
        '@CONFIG/LIST_SUCCESS',
        '@CONFIG/LIST_FAILURE'
    )<undefined, Config[], void>(),
    update: createAsyncAction(
        '@CONFIG/UPDATE_REQUEST',
        '@CONFIG/UPDATE_SUCCESS',
        '@CONFIG/UPDATE_FAILURE'
    )<Config, Config, void>(),
    startEdit: createAction('@CONFIG/START_EDIT')<Config>(),
    cancelEdit: createAction('@CONFIG/CANCEL_EDIT')(),
}

export { actions as configActions }

export interface ConfigState {
    editState: ADTType<typeof ConfigEditState>,
    status: RequestStatus,
    data: Config[],
}

export const configReducer = combineReducers<ConfigState>({
    editState: createReducer<ADTType<typeof ConfigEditState>>(ConfigEditState.as.none({}))
        .handleAction([actions.cancelEdit, actions.update.success], () => ConfigEditState.as.none({}))
        .handleAction(actions.startEdit, (_, action) => ConfigEditState.as.update({payload: action.payload})),
    status: createReducer<RequestStatus>(RequestStatus.INITIAL)
        .handleAction(actions.list.request, () => RequestStatus.FETCHING)
        .handleAction(actions.list.success, () => RequestStatus.SUCCESS)
        .handleAction(actions.list.failure, () => RequestStatus.FAILURE),
    data: createReducer<Config[]>([])
        .handleAction(actions.list.success, payloadReducer)
        .handleAction(actions.update.success, (state, action) => entityReplace(action.payload)(state)),
})

const list: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.list.request)),
    switchMap(() => apiRequests.dictionary.configList({})),
    map(res => res.response.success ?
        actions.list.success(res.response.rows) :
        actions.list.failure(toastFailedResponse(res.response, 'Ошибка загрузки'))
    ),
)

const update: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.update.request)),
    mergeMap(action => apiRequests.dictionary.configUpdate({
        data: action.payload,
        params: { key: action.payload.key },
    })),
    map(res => res.response.success ?
        actions.update.success(res.response.row) :
        actions.update.failure(toastFailedResponse(res.response, 'Ошибка обновления'))
    ),
)

export const configEpic = combineEpics(list, update)